module.exports = __webpack_public_path__ + "img/03.ce9b7a84.jpg";